import * as React from 'react';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { Error } from '../../components/Error';
import { fetchOrganizationIfNeeded } from '@pec/aion-ui-core/actions/organization';
import { fetchServerTokensIfNeeded } from '@pec/aion-ui-core/actions/serverTokens';
import { fetchUserInfoIfNeeded, hasPermission } from '@pec/aion-ui-core/actions/userInfo';
import { Loading } from '../../components/Loading';
import { Location } from 'history';
import { ReportsSection as ReportsSectionComponent } from '../../components/Nav/ReportsSection';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';
import { UserInfoActivitiesType } from '@pec/aion-ui-core/interfaces/userInfo';

type OwnProps = {
  organizationId: string;
  location: Location;
};

const mapStateToProps = ({
  organization: { organization, isFetching: isFetchingOrganization, fetchError: organizationFetchError },
  serverTokens: { serverTokens, isFetching: isFetchingServerTokens, error: serverTokensError },
  userInfo: { userInfo, isFetching: isFetchingUserInfo, error: userInfoError }
}: CommonRootState) => {
  const isFetching = isFetchingOrganization || isFetchingServerTokens || isFetchingUserInfo;
  const error = organizationFetchError || serverTokensError || userInfoError;
  return {
    organization,
    serverTokens,
    userInfo,
    isFetching,
    error
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<CommonRootState, null, RootActions>,
  { organizationId }: OwnProps
) => ({
  fetchOrganizationIfNeeded: () => dispatch(fetchOrganizationIfNeeded(organizationId)),
  fetchServerTokensIfNeeded: () => dispatch(fetchServerTokensIfNeeded()),
  fetchUserInfoIfNeeded: () => dispatch(fetchUserInfoIfNeeded())
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

class ReportsSection extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.fetchOrganizationIfNeeded();
    props.fetchServerTokensIfNeeded();
    props.fetchUserInfoIfNeeded();
  }

  hasGlobalPermission = (action: ActivityAction, resourceName: ActivityResourceName) =>
    hasPermission(this.props.userInfo, action, resourceName);

  hasOrganizationPermission = (action: ActivityAction, resourceName: ActivityResourceName) => {
    const { userInfo, organizationId } = this.props;

    return organizationId
      ? hasPermission(userInfo, action, resourceName, [
          {
            type: UserInfoActivitiesType.Organization,
            id: organizationId
          }
        ])
      : false;
  };

  render() {
    const { isFetching, organization, serverTokens, error } = this.props;
    return !isFetching && organization && serverTokens ? (
      <ReportsSectionComponent
        hasGlobalPermission={this.hasGlobalPermission}
        hasOrganizationPermission={this.hasOrganizationPermission}
        organizationId={organization.id}
        features={organization.features}
        serverTokens={serverTokens}
      />
    ) : error ? (
      <Error />
    ) : (
      <Loading />
    );
  }
}

export const ReportsSectionContainer = connect(mapStateToProps, mapDispatchToProps)(ReportsSection);
